var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProductPageModule',{attrs:{"data":_vm.document.data,"data-luko-tracking":"Page-Products_slug"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }